import { CalculatorInputs } from "../../model/CalculatorInputs";
import { CalculatorConfig } from "../../model/CalculatorConfig";
import { CalculatorResultsStore } from "../Store/CalculatorResultsContext";

import { CancelTokenSource } from "axios";
import { pipe } from "fp-ts/lib/pipeable";
import { fold, some, none, getOrElse } from "fp-ts/lib/Option";
import { fold as foldEither } from "fp-ts/lib/Either";

import { exportPdf, getPDFUrl, EXPORT_CANCELLED_MESSAGE } from "../../api/CalculatorApi";
import {
  analyticsErrorEvent,
} from "../../utils/Analytics";

export async function generatePDFExport(
  inputs: CalculatorInputs,
  cancelTokenSource: CancelTokenSource,
  config: CalculatorConfig,
  resultsStore: CalculatorResultsStore
) {
  resultsStore.setPdfUrl(none);
  resultsStore.setPdfExportError(none);
  resultsStore.setExportingPdfCancelled(false);
  resultsStore.setExportingPdf(true);

  pipe(
    resultsStore.results,
    fold(
      () => {
        // called Export when no results available; UI error
        const err = "Cannot Export PDF, please run calculation first";
        resultsStore.setPdfExportError(some(err));
      },
      async (response) => {
        const exportResponse = await exportPdf(
          response,
          inputs,
          config,
          cancelTokenSource.token
        );
        pipe(
          exportResponse,
          foldEither(
            (err) => {
              resultsStore.setPdfUrl(none);
                console.log(err);
                // if user cancelled this operation, the error message will be 'CANCELLED'
                if (err.toString() !== EXPORT_CANCELLED_MESSAGE) {
                    resultsStore.setPdfExportError(some(err.toString()));
                    analyticsErrorEvent("ToolError", err.toString()); // TODO: Analytics
                }
            },
            (response) => {
              const { appId, checkSum, docNumber } = response.reportURL;
              const productCusip = getOrElse(() => '')(config.productCusip);
              const url = getPDFUrl(config, appId, checkSum, docNumber, productCusip);
              resultsStore.setPdfExportError(none);
              resultsStore.setPdfUrl(some(url));
              // analyticsToolPDFExportEvent(inputs, config); // TODO: Analytics
            }
          )
        );
        resultsStore.setExportingPdf(false);
      }
    )
  );
}

// export async  function cancelPDFExport(cancelTokenSource: CancelTokenSource,
//     config: CalculatorConfig,
//     resultsStore: CalculatorResultsStore) {

//         cancelTokenSource.cancel();


//     }

/*
export const fetchResults = async (inputs: CalculatorInputs, config: CalculatorConfig,
    resultsStore: CalculatorResultsStore) => {

    resultsStore.setResults(none);
    resultsStore.setLoading(true);
    const realResult: Either<Error, CalculatorResponse> = await calculate(inputs, config);
    resultsStore.setConfig(config);
    resultsStore.setLoading(false);
    pipe(
        realResult,
        fold(
            (err) => {
                resultsStore.setResults(none);
                resultsStore.setError(some(err.toString()));
                analyticsErrorEvent("ToolError", err.toString());
            },
            (response) => {
                resultsStore.setError(none);
                resultsStore.setResults(some((response)));  
                analyticsToolCompleteEvent(inputs, config);
            }
        )
    );
}


*/
